import logo from './logo.svg';
import './App.css';
import {
  BrowserRouter as Router,
  Routes, Route, useLocation, useRoutes, useParams
} from "react-router-dom";
import { DatePicker } from 'antd';
import Mainroute from './Product1/Pages/Mainroute';
import Successpage from './Product1/Pages/Successpage';
import Imgmeesho from './Product1/Pages/Imgmeesho';
import Newimgmeesho from './Product1/Pages/Newimgmeesho';
import Meeshoprice from './Product1/Pages/Meeshoprice';
import PrivateListingTool from './Product1/Pages/PrivateListingTool';




function App() {
  return (
    <Router>
      <Routes>
        <Route path='/*' element={
          <div className="mobile-container">
            <p>Hello World </p>

          </div>}
        />

        <Route path='/trk/pay1' element={<Mainroute />} />
        <Route path='/trk/success/:id' element={<Successpage />} />
        <Route path='/ms' element={<Newimgmeesho />} />
        <Route path='/meesho' element={<Meeshoprice />} />
        <Route path='/msnew' element={<PrivateListingTool />} />




      </Routes>

    </Router>
  );
}

export default App;
